import React, { useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { Image } from 'react-bootstrap';
import { Anchor } from 'antd';
import { ProcessEnvConfig } from 'config/ProcessEnvConfig';
import { CampaignType, EarningRuleType } from 'config/CustomEnums';
import CustomTips from 'components/base/CustomTips';
import './AnchorPage.scss';

import CloseButton from '../../assets/images/campaignStreamline/close.png';
import TitleError from '../../assets/images/campaignStreamline/title_error.png';
import { validate } from 'containers/engagement/campaignStreamline/CreateCampaignValidate';
import { getHideInFrontend } from 'models/CreateCampaignModel';
import {
  CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY,
  CAMPAIGN_COUPON_PAGE_ANCHOR_KEY,
  CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY,
  CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY,
  COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY
} from 'config/PageAnchorConfig/CampaignAnchorConfig';

const { Link } = Anchor;

export const getContentPageAnchor = (
  hideInFrontend,
  campaignType,
) => {
  if (campaignType === CampaignType.generalMessageCampaign) {
    return [
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.general.sectionKey, title: 'General' },
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionKey, title: 'Target customers' },
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionKey, title: 'Key visual' },
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.instruction.sectionKey, title: 'Instruction' },
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.detail.sectionKey, title: 'Detail' },
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionKey, title: 'Front end display' },
      ...(
        ProcessEnvConfig.haveShopMall
          ? [{ anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.mall.sectionKey, title: 'Mall' }]
          : []
      ),
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.activePeriod.sectionKey, title: 'Active period' },
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionKey, title: 'Visible period' },
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey, title: 'Recurring Campaign' },
    ]
  }


  if (hideInFrontend) {
    return [
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.displayInFrontend.sectionKey, title: 'Display this campaign in fronted' },
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.general.sectionKey, title: 'General' },
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionKey, title: 'Target customers' },
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.activePeriod.sectionKey, title: 'Active period' },
      { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey, title: 'Recurring Campaign' },
    ];
  };

  return [
    { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.displayInFrontend.sectionKey, title: 'Display this campaign in fronted' },
    { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.general.sectionKey, title: 'General' },
    { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionKey, title: 'Target customers' },
    { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionKey, title: 'Key visual' },
    { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.instruction.sectionKey, title: 'Instruction' },
    { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.detail.sectionKey, title: 'Detail' },
    { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionKey, title: 'Front end display' },
    ...(
      ProcessEnvConfig.haveShopMall
        ? [{ anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.mall.sectionKey, title: 'Mall' }]
        : []
    ),
    { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.activePeriod.sectionKey, title: 'Active period' },
    { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionKey, title: 'Visible period' },
    { anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey, title: 'Recurring Campaign' },
  ]
};

export const getEarningRuleAnchor = (earningRuleType) => {
  switch (earningRuleType) {
    case EarningRuleType.generalPurchase:
      return [
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.requirements.sectionKey, title: 'Spending requirements' },
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey, title: 'Reward' },
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.executionPriority.sectionKey, title: 'Execution priority for global limit' },
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.limit.sectionKey, title: 'Limit' },
      ];
    case EarningRuleType.newMember:
      return [
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.promotionCode.sectionKey, title: 'Promotion code' },
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey, title: 'Reward' },
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.executionPriority.sectionKey, title: 'Execution priority for global limit' },
      ];
    case EarningRuleType.memberReferral:
    case EarningRuleType.fillingForm:
      return [
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey, title: 'Reward' },
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.executionPriority.sectionKey, title: 'Execution priority for global limit' },
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.limit.sectionKey, title: 'Limit' },
      ];
    case EarningRuleType.birthday:
      return [
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey, title: 'Reward' },
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.executionPriority.sectionKey, title: 'Execution priority for global limit' },
      ];
    case EarningRuleType.qrCodeScanning:
    case EarningRuleType.gpsCheckIn:
      return [
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.requirements.sectionKey, title: 'Requirements' },
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey, title: 'Reward' },
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.limit.sectionKey, title: 'Limit' },
      ]
    default:
      return [
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.requirements.sectionKey, title: 'Requirements' },
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey, title: 'Reward' },
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.executionPriority.sectionKey, title: 'Execution priority for global limit' },
        { anchorKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.limit.sectionKey, title: 'Limit' },
      ]
  }
};
export const getCouponCampaignRulePageAnchor = (showLimit) => {
  return [
    { anchorKey: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.requirementsSection.sectionKey, title: 'Requirements' },
    ...showLimit ? [{ anchorKey: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.limitSection.sectionKey, title: 'Limit' }] : [],
  ]
}

export const getCouponPageAnchor = () => {
  return [
    { anchorKey: CAMPAIGN_COUPON_PAGE_ANCHOR_KEY.couponGeneral.sectionKey, title: 'General' },
    { anchorKey: CAMPAIGN_COUPON_PAGE_ANCHOR_KEY.couponKeyVisual.sectionKey, title: 'Key visual' },
    { anchorKey: CAMPAIGN_COUPON_PAGE_ANCHOR_KEY.couponInstruction.sectionKey, title: 'Instruction' },
    { anchorKey: CAMPAIGN_COUPON_PAGE_ANCHOR_KEY.couponDetail.sectionKey, title: 'Detail' },
    { anchorKey: CAMPAIGN_COUPON_PAGE_ANCHOR_KEY.validPeriod.sectionKey, title: 'Coupon valid period' },
    { anchorKey: CAMPAIGN_COUPON_PAGE_ANCHOR_KEY.applicableStores.sectionKey, title: 'Coupon applicable store' },
    { anchorKey: CAMPAIGN_COUPON_PAGE_ANCHOR_KEY.couponProperties.sectionKey, title: 'Code setting' },
    { anchorKey: CAMPAIGN_COUPON_PAGE_ANCHOR_KEY.generateCoupons.sectionKey, title: 'Import/Generate single coupons' },
    { anchorKey: CAMPAIGN_COUPON_PAGE_ANCHOR_KEY.additionalData.sectionKey, title: 'Additional data' },
  ]
}

export const handleClick = (e, link, dispatch) => {
  e.preventDefault();
  console.log("@@16", link);
};

export const AnchorSubTitle = ({
  item,
  errorSectionList,
}) => (
  <div className='anchor-title-error-container'>
    {
      errorSectionList.includes(item.anchorKey) && (
        <Image
          src={TitleError}
          className="anchor-title-error"
        />
      )
    }
    <Link className='anchor-sub-title' href={`#${item.anchorKey}`} title={item.title} />
  </div>
)

const AnchorPage = ({
  hideCampaignNavigationTip,
  errorSectionList,
  stepWithCoupon,
}) => {
  const dispatch = useDispatch();
  const { getValues, clearErrors, setError } = useFormContext();

  const campaign = getValues();

  const [showTips, setShowTips] = useState(!hideCampaignNavigationTip);

  const hideInFrontend = getHideInFrontend({ getValues });

  const contentPageAnchor = getContentPageAnchor(hideInFrontend, campaign.campaignType);
  const isEarningCampaign = campaign.campaignType === CampaignType.earningRulesCampaign;
  const isCouponCampaign = campaign.campaignType === CampaignType.couponsCampaign;
  const earningRuleAnchor = getEarningRuleAnchor(campaign.linkedEarningRules?.type);
  const couponPageAnchor = getCouponPageAnchor();
  const couponCampaignShowLimit = isCouponCampaign && campaign?.showCouponLimit
  const couponCampaignRulePageAnchor = getCouponCampaignRulePageAnchor(couponCampaignShowLimit);
  return (
    <div className='anchor-page-container'>
      <div className='anchor-page-navigation-container'>
        <label
          className="create-section-title anchor-page-title"
          onClick={() => setShowTips(!showTips)}
        >
          NAVIGATION
          <CustomTips
            popoverClassName="tips-popover"
            detail={
              <div className='anchor-tips'>
                <Image
                  src={CloseButton}
                  className="tips-close"
                  onClick={() => {
                    setShowTips(false);
                  }}
                />
                <span>
                  On Approve/Publish, missing required fields are marked
                  with a warning icon. Click “Fill Now” to complete.
                  When you have completed filling in the fields, you can click 'Refresh' to update
                </span>
                <span
                  className='anchor-page-do-not-display-again'
                  onClick={() => {
                    setShowTips(false);
                    dispatch({
                      type: 'settings/updateAdminTipConfig',
                      payload: {
                        data: {
                          hideCampaignNavigationTip: true,
                        }
                      }
                    })
                  }}
                >
                  Do not display again
                </span>
              </div>
            }
            placement="top"
            show={showTips}
          />
        </label>
        <span
          className='anchor-refresh-error'
          onClick={() => {
            validate({
              stepWithCoupon,
              dispatch,
              getValues: getValues,
              setError,
              clearErrors,
              checkCheckList: true,
            });
          }}
        >
          Refresh
        </span>
      </div>

      <Anchor
        offsetTop={90}
        onClick={(e, link) => handleClick(e, link, dispatch)}
      >
        <Link className='anchor-title' href={`#${CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.contentPage}`} title="Content" >
          {
            contentPageAnchor.map(item => (
              <AnchorSubTitle item={item} errorSectionList={errorSectionList} />
            ))
          }
        </Link>
        {
          isEarningCampaign && (
            <Link className='anchor-title' href={`#${CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.earningRulePage}`} title="Rule & Properties" >
              {
                earningRuleAnchor.map(item => (
                  <AnchorSubTitle item={item} errorSectionList={errorSectionList} />
                ))
              }
            </Link>
          )
        }
        {
          isCouponCampaign && (
            <Link className='anchor-title' href={`#${CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.earningRulePage}`} title="Rule & Properties" >
              {
                couponCampaignRulePageAnchor.map(item => (
                  <AnchorSubTitle item={item} errorSectionList={errorSectionList} />
                ))
              }
            </Link>
          )
        }
        {stepWithCoupon && <Link className='anchor-title' href={`#${CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.couponPage}`} title="Coupon set" >
          {
            couponPageAnchor.map(item => (
              <AnchorSubTitle item={item} errorSectionList={errorSectionList} />
            ))
          }
        </Link>}
        {!stepWithCoupon && isCouponCampaign && (
          <div className='check-list-error-container'>
            {
              errorSectionList.includes(CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.checklist) && (
                <Image
                  src={TitleError}
                  className="check-list-error"
                />
              )
            }
            <Link className='anchor-title' href={`#${CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.checklist}`} title="Check list" />
          </div>
        )}
      </Anchor>
    </div>
  );
};

const mapStateToProps = (state) => ({
  hideCampaignNavigationTip: state.settings.adminTipConfig?.hideCampaignNavigationTip,
  errorSectionList: state.createCampaign.errorSectionList,
  stepWithCoupon: state.campaignStreamline.stepWithCoupon,
})

export default connect(mapStateToProps)(AnchorPage);
